"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToShortenedMonthString = void 0;
function transformDateToShortenedMonthString(date) {
    const dateToStringify = new Date(date);
    const year = dateToStringify.getUTCFullYear().toString();
    const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][dateToStringify.getUTCMonth()];
    const day = dateToStringify.getUTCDate().toString();
    return `${day} ${month}, ${year}`;
}
exports.transformDateToShortenedMonthString = transformDateToShortenedMonthString;
//# sourceMappingURL=transformDateToShortenedMonthString.js.map